import { cloneDeep } from "lodash";

const DEFAULT_ATTRIBUTES = {
  accepted_tariff: false,
  active: false,
  active_services: [],
  average_volume: 0,
  balance: 0,
  billing_email: "",
  business_name: "",
  deactivate_reason: null,
  dnd: false,
  doc_number: null,
  doc_type: null,
  email: null,
  fiscal_category: "",
  fiscal_industries_ids: [],
  fiscal_taxes: [],
  hero_image_url: null,
  iibb_url: null,
  image_url: null,
  insurance_policy_type: "",
  insurance_policy_value: 0,
  last_name: null,
  name: null,
  onboarding: null,
  payment_modality: "",
  phone: null,
  picking_preference_own: "",
  send_stock_email: true,
  support_type: null,
  test: false,
  url: "",
  valid_fiscal_industry: false,
  salesforce_id: null,
};

export class Account {
  constructor(attributes) {
    const attrs = { ...cloneDeep(DEFAULT_ATTRIBUTES), ...attributes };
    Object.keys(attrs).forEach((key) => {
      this[key] = attrs[key];
    });
  }

  //? methods related to the displayed information.
  get cookedCompanyName() {
    return this.company_name || "";
  }

  //? methods related to account permissions.
  get isShipnow() {
    return this.id === 1;
  }

  get isWarehouseOwner() {
    return this.stats.warehouses.with_warehouse_system > 0;
  }

  //? account types
  get isFullfilment() {
    return this.picking_preference_own === "warehouse";
  }

  get isCrossdocking() {
    return this.picking_preference_own === "cross_docking";
  }

  //? account features
  get hasChatSupport() {
    return this.support_type === "chat" && !this.isShipnow;
  }

  //? account status
  get isWaitingOnboarding() {
    return this.deactivate_reason === "waiting_for_onboarding";
  }

  //? onboarding methods
  get isOnboardingPreferencePickingIncomplete() {
    return this.picking_preference_own === null;
  }

  get isOnboardingAboutBuisnessIncomplete() {
    return (
      this.onboarding.industry === null ||
      this.onboarding.monthly_orders === null ||
      (this.isCrossdocking && this.onboarding.location === null)
    );
  }

  get isOnboardingOperationConstraintsAccepted() {
    return this.onboarding.accepted_operation_constraints === true;
  }

  get isOnboardingProductsSizeIncomplete() {
    return (
      this.onboarding.avg_variant_type.length === 0 &&
      !this.onboarding.variant_avg_height &&
      !this.onboarding.variant_avg_width &&
      !this.onboarding.variant_avg_length
    );
  }

  get isIncompleteOnboarding() {
    return (
      this.isWaitingOnboarding &&
      (!this.onboarding ||
        this.isOnboardingPreferencePickingIncomplete ||
        this.isOnboardingAboutBuisnessIncomplete ||
        !this.isOnboardingOperationConstraintsAccepted ||
        this.isOnboardingProductsSizeIncomplete)
    );
  }

  //? account payment methods
  //? TODO: pasarlos a get
  isPrePaid() {
    return this.payment_modality === "prepaid";
  }

  isPostPaid() {
    return this.payment_modality === "postpaid";
  }

  hasNoBalance() {
    return this.balance <= 0;
  }

  hasBalance() {
    return this.balance > 0;
  }

  hasAddUpBalance() {
    return this.isPrePaid() && this.balance >= 0 && this.balance <= 3000;
  }

  isPrepaidWithoutBalance() {
    return this.isPrePaid() && this.isDisabledByDebt() && this.hasNoBalance();
  }

  isPostpaidWithoutBalance() {
    return this.isPostPaid() && this.isDisabledByDebt();
  }

  isAccountWithoutBalance() {
    return this.isPrepaidWithoutBalance() || this.isPostpaidWithoutBalance();
  }

  //? warehouses methods
  get hasMultipleShipnowWarehouse() {
    return this.stats.warehouse_accounts.with_warehouse_system > 1;
  }
}
